export const fileFromSVGElement = (svgEl) => {
  const source = (new XMLSerializer()).serializeToString(svgEl);
  return new Blob([source], { type: 'image\/svg+xml' });
}

export const textToFrag = (text) => {
  return document.createRange().createContextualFragment(text);
};

export const fragToText = (frag) => {
  return frag.lastChild
    ? elementToText(frag.lastChild)
    : '';
};

export const fragToElement = (frag) => {
  return frag.lastChild
    ? frag.lastChild
    : null;
};

export const textToElement = (text) => {
  return fragToElement(textToFrag((text)));
};

export const fileToSVGElement = async (file) => {
  const fileReader = new FileReader();

  return new Promise((resolve, reject) => {
    fileReader.onerror = () => {
      fileReader.abort();
      reject(new Error('Could not read file'));
    };

    fileReader.onload = () => resolve(textToElement(fileReader.result));

    fileReader.readAsText(file);
  });
};
